import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import isEmpty from 'lodash/isEmpty'
import Divider from '../../BaseComponents/Divider'
import BigButton from '../../BaseComponents/Button/Standard/Big'
import { TestID } from '../../utils/PropTypesDefinitions'

export type OnboardingButtonNavigationProps = {
    rightButtonText: string
    onRightButtonPress: () => void
    leftButtonText?: string
    onLeftButtonPress?: () => void
} & TestID

const OnboardingButtonNavigation: FunctionComponent<OnboardingButtonNavigationProps> = ({
    rightButtonText,
    onRightButtonPress,
    leftButtonText = 'Fertig',
    onLeftButtonPress,
    testID,
}): ReactElement => {
    return (
        <>
            <Divider dark testID={`${testID}_divider`} />
            <Grid
                noExpand
                height={59}
                horizontal
                centerVertical
                backgroundColor="tahitian-3"
                testID={testID}
            >
                {onLeftButtonPress && !isEmpty(leftButtonText) ? (
                    <Grid paddingLeft={5}>
                        <BigButton
                            testID={`${testID}_leftButton`}
                            expand
                            onPress={onLeftButtonPress}
                            backgroundColor="pearl"
                        >
                            {leftButtonText}
                        </BigButton>
                    </Grid>
                ) : null}
                <Grid paddingX={5}>
                    <BigButton
                        testID={`${testID}_rightButton`}
                        expand
                        onPress={onRightButtonPress}
                        backgroundColor="onyx"
                    >
                        {rightButtonText}
                    </BigButton>
                </Grid>
            </Grid>
        </>
    )
}

export default memo(OnboardingButtonNavigation)
